/**
 * Global Menu
 */
// export function global_menu() {
//   /**
//    * サブメニュー
//    */
//   document.addEventListener('DOMContentLoaded', function() {
//     const submenuItems = document.querySelectorAll('#global-nav li[data-has="has-submenu"]');

//     submenuItems.forEach(item => {
//       item.addEventListener('mouseenter', function () {
//         item.classList.add('is-active');
//       });

//       item.addEventListener('mouseleave', function () {
//         item.classList.remove('is-active');
//       });
//     });
//   });
// }

// // htmxで読み込み対応
// function attachHover () {
//   const items = document.querySelectorAll('#global-nav li[data-has="has-submenu"]');
//   // console.log('[global_menu] attachHover →', items.length, 'items');

//   items.forEach(item => {
//     if (item.dataset.hoverReady === 'true') return;      // 二重登録防止
//     item.addEventListener('mouseenter', () => item.classList.add('is-active'));
//     item.addEventListener('mouseleave', () => item.classList.remove('is-active'));
//     item.dataset.hoverReady = 'true';
//   });
// }

// export function global_menu () {

//   /* 1️⃣ まず “今ある DOM” に対して hover を試みる
//         （トップページではここで付く。サブページでは 0 件でも OK） */
//   attachHover();

//   /* 2️⃣ まだ DOM が構築途中なら、DOMContentLoaded でもう一度試す */
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', attachHover, { once: true });
//   }

//   /* 3️⃣ そして **すぐに** htmx.onLoad を登録する
//         → これでヘッダー差し替え直後の onLoad を取りこぼさない */
//   if (window.htmx && typeof window.htmx.onLoad === 'function') {
//     window.htmx.onLoad(() => {
//       // console.log('[global_menu] htmx.onLoad → re-attach');
//       attachHover();
//     });
//   } else {
//     // console.warn('[global_menu] htmx.onLoad が見つかりません (htmx 2.x 必須)');
//   }
// }

// PHPのinclude対応
function attachHover () {
  const items = document.querySelectorAll('#global-nav li[data-has="has-submenu"]');
  // console.log('[attachHover] items:', items.length);

  items.forEach(item => {
    if (item.dataset.hoverReady === 'true') return; // 再登録防止（JSでのみ管理）

    item.addEventListener('mouseenter', () => {
      item.classList.add('is-active');
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-active');
    });

    item.dataset.hoverReady = 'true';
  });
}

export function global_menu () {
  // console.log('[global_menu] init');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // console.log('[global_menu] DOMContentLoaded');
      attachHover();
    }, { once: true });
  } else {
    // console.log('[global_menu] DOM already ready');
    attachHover();
  }
}
